import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import React__default from 'react';
import clsx from 'clsx';
import { Text } from '../Text/Text.js';
import { Base } from '../../Internal/Base/Base.js';
import '../../Internal/Badge/Badge.js';
import '@treatwell/design-tokens';
import { InlineLoading } from '../../Internal/InlineLoading/InlineLoading.js';
import '../../Layout/Box/Box.js';
import { Inline } from '../../Layout/Inline/Inline.js';
import '../../Layout/Stack/Stack.js';
import buttonStyles from './Button.module.css.js';

const Button = React__default.forwardRef(({ children, disabled, isLoading = false, type = 'button', icon, iconPosition = 'left', buttonStyle = 'primary', size = 'lg', fullWidth = false, className, ...restProps }, ref) => {
    const buttonStyles$1 = clsx(className, buttonStyles.button, buttonStyles[buttonStyle], buttonStyles[size], {
        [buttonStyles.disabled]: disabled,
        [buttonStyles.onLoading]: isLoading,
        [buttonStyles.fullWidth]: fullWidth,
    });
    return (jsxRuntimeExports.jsx(Base, { as: "button", className: buttonStyles$1, type: type, forwardRef: ref, disabled: disabled, ...restProps, children: jsxRuntimeExports.jsxs(Inline, { justify: "center", space: "xs", children: [isLoading && jsxRuntimeExports.jsx(InlineLoading, {}), !isLoading && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [iconPosition === 'left' && icon, jsxRuntimeExports.jsx(Text, { type: "bodyHeavy", children: children }), iconPosition === 'right' && icon] }))] }) }));
});
Button.displayName = 'Button';

export { Button };
//# sourceMappingURL=Button.js.map
